import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import * as ep from '../api/endpoints';
import { PeriodPicker, usePeriods } from '../components/PeriodPicker';
import { Empty, ErrorBox, Loading, Money, ReceiptBadge } from '../components/ui';
import { formatDate } from '../lib/dates';
import { formatTL, apiToKurus } from '../lib/money';

/** Ortak havuz (K03): kişi, tarih aralığı, kategori, durum filtreleri. Varsayılan: seçili ay aktif + kısmi iadeli. */
export function PoolScreen() {
  const [params, setParams] = useSearchParams();
  const periods = usePeriods();
  const periodId = params.get('period_id') ?? periods.data?.[0]?.id;
  const [q, setQ] = useState('');
  const filters = {
    period_id: periodId,
    owner_id: params.get('owner_id') ?? undefined,
    category: params.get('category') ?? undefined,
    status: params.get('status') ?? 'active',
    date_from: params.get('date_from') ?? undefined,
    date_to: params.get('date_to') ?? undefined,
    q: q || undefined,
  };
  const members = useQuery({ queryKey: ['members'], queryFn: ep.members });
  const list = useQuery({ queryKey: ['receipts', filters], queryFn: () => ep.receipts(filters), enabled: !!periodId });
  const set = (k: string, v: string) => { const p = new URLSearchParams(params); if (v) p.set(k, v); else p.delete(k); setParams(p, { replace: true }); };
  const total = (list.data ?? []).reduce((s, r) => s + apiToKurus(r.net_contribution ?? r.amount), 0n);

  return (
    <div>
      <h1>Ortak havuz</h1>
      <div className="filters">
        <PeriodPicker value={periodId} onChange={(v) => set('period_id', v)} />
        <select aria-label="Kişi" value={filters.owner_id ?? ''} onChange={(e) => set('owner_id', e.target.value)}>
          <option value="">Tüm kişiler</option>
          {members.data?.map((m) => <option key={m.user_id} value={m.user_id}>{m.full_name}{m.is_active ? '' : ' (pasif)'}</option>)}
        </select>
        <select aria-label="Durum" value={filters.status} onChange={(e) => set('status', e.target.value)}>
          <option value="active">Aktif ve kısmi iadeli</option>
          <option value="all">Tümü</option>
          <option value="cancelled">İptal</option>
          <option value="refunded_full">Tam iade</option>
          <option value="refunded_partial">Kısmi iade</option>
        </select>
        <input aria-label="Kategori" placeholder="Kategori" value={filters.category ?? ''} onChange={(e) => set('category', e.target.value)} />
        <input aria-label="Başlangıç" type="date" value={filters.date_from ?? ''} onChange={(e) => set('date_from', e.target.value)} />
        <input aria-label="Bitiş" type="date" value={filters.date_to ?? ''} onChange={(e) => set('date_to', e.target.value)} />
        <input aria-label="Ara" placeholder="Açıklama, satıcı, kişi ara" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      <ErrorBox error={list.error} />
      {list.isLoading ? <Loading /> : (
        <div className="card">
          <div className="row small muted" style={{ marginBottom: 6 }}>
            <span>{list.data?.length ?? 0} fiş</span><span className="spacer" /><span>Listedeki net katkı: <strong className="num">{formatTL(total)}</strong></span>
          </div>
          <ul className="list">
            {list.data?.map((r) => (
              <li key={r.id}>
                <Link to={`/fis/${r.id}`}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="title">{r.description || r.category}</div>
                    <div className="small muted">{r.category} · {r.owner_name} · {formatDate(r.document_date)}</div>
                    {r.payment_method === 'CREDIT_SALE' && <span className="badge warn">Veresiye · son ödeme {formatDate(r.payment_due_date)}</span>}
                  </div>
                  <ReceiptBadge status={r.status} />
                  <Money value={r.amount} />
                </Link>
              </li>
            ))}
          </ul>
          {!list.data?.length && <Empty>Bu filtrelerle fiş bulunamadı.</Empty>}
        </div>
      )}
    </div>
  );
}
